export const ID_LOADING = "LOADING";
export const ID_PROCESSED = "PROCESSED";
export const ID_IMPORTED = "IMPORTED";
export const ID_BILLABLE = "BILLABLE";
export const ID_BILLED = "BILLED";
export const ID_REJECTED = "REJECTED";
export const ID_REPLACED = "REPLACED";
export const ID_SENT = "SENT";
